module.exports = __webpack_public_path__ + "static/media/instagram.ee8629aa.png";